import { UtilitiesService } from 'src/app/shared/services/utilities.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Company } from 'src/app/shared/models/companies';
import { FileItem } from 'src/app/shared/models/fileItems';
import { Level } from '../../shared/enums/level.enum';
import { CompaniesService } from 'src/app/shared/services/companies.service';
import RemoteFileSystemProvider from 'devextreme/file_management/remote_provider';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {
  _subscriptions: Subscription[] = [];
  companiesList: Company[] = [];
  imageItemToDisplay: any = {};
  popupVisibleDocument = false;
  remoteProvider: RemoteFileSystemProvider;
  usdt: any;
  id_companies_list: any[]=[];

  constructor(
    private router: Router,
    private utilitiesServices: UtilitiesService,
    public companiesService: CompaniesService
  ) {
    this.usdt = this.utilitiesServices.getUserData();
    switch (this.usdt.level) {
      case Level.ihunterSuperUser:
        this._subscriptions.push(
          companiesService.getCompanies().subscribe(companies => {
              this.companiesList = companies;
          })
        );
        break;
      case Level.ihunterAdmin:
        this._subscriptions.push(
          companiesService.getCompanies().subscribe(companies => {
              this.companiesList = companies;
          })
        );
        break;
      case Level.ihunterReportes:
        this._subscriptions.push(
          companiesService.getCompanies().subscribe(companies => {
              this.companiesList = companies;
          })
        );
        break;
      case Level.Broker:
        if (this.usdt.companyList) {
          this.usdt.companyList.forEach(company => {
            this.id_companies_list.push(company.id.trim());
          });
        }
        this._subscriptions.push(
          companiesService.getCompanies().subscribe(companies => {
              this.companiesList = companies.filter(company => this.id_companies_list.includes(company.id));
          })
        );
        break;
        default:
          break;
    }
  }

  ngOnInit() {
  }

  addCompany() {
    this.router.navigate(['/dash/companies/new/']);
  }

  updateCompany(company){
    this.router.navigate(['/dash/companies/update//', {idCompany : company.data.id}]);
  }

  displayImagePopup(e) {
    this.imageItemToDisplay = e.file;
    this.popupVisibleDocument = true;
  }
  
  ngOnDestroy() {
    this._subscriptions.forEach((sub) => sub.unsubscribe);
  }

}
